// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__BE2UA","customBackground":"Modal_customBackground__vM+4O","container":"Modal_container__EY5Qx","close":"Modal_close__nnot4"};